import { takeLatest, put, call, take } from 'redux-saga/effects';
import { HTTP_HEADERS, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import { CORE_API } from '../../../config';
import * as CorporateCaseCountAction from './action';

export function* fetchCorporateList(action) {
    let requestUrl = `${CORE_API}/corporate/filtermodel/list`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', data: '', headers: HTTP_HEADERS });
        yield put(CorporateCaseCountAction.listCorporateSuccess(createResult.data));
    } catch (err) {
        if (!err.response) {
            yield put(CorporateCaseCountAction.listCorporateFailure(false))
        } else {
            yield put(CorporateCaseCountAction.listCorporateFailure(err))
        }

    }
}
export function* getCorporateList(action) {
    yield takeLatest(CorporateCaseCountAction.LIST_CORPORATE, fetchCorporateList);
}

export function* fetchCorporateCaseCount(action) {
    let requestUrl = `${CORE_API}/corporate/casecount/${action.data.corporateId}/${action.data.isActive}/${action.data.pageNo}/${action.data.pageSize}`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(CorporateCaseCountAction.fetchCorporateCaseCountSuccess(createResult));
    } catch (err) {
        yield put(CorporateCaseCountAction.fetchCorporateCaseCountFailure(err))
    }
}

export function* getCorporateCaseCount() {
    yield takeLatest(CorporateCaseCountAction.FETCH_CORPORATE_CASE_COUNT, fetchCorporateCaseCount);
}

